import { defineAsyncComponent } from 'vue';
import HawkLoader from '~/common/components/atoms/hawk-loader.vue';
import Photos from '~/photos/pages/photos.vue';

const PhotosList = defineAsyncComponent({
  loader: () => import('~/photos/pages/photos-list.vue'),
  loadingComponent: HawkLoader,
});

const routes = [
  {
    path: '/:asset_id?/photos',
    name: 'photos',
    component: Photos,
    meta: {
      title: 'Photos',
      requireModuleAccess: 'photos',
      module: 'photos',
      parent: 'photos',
    },
    redirect: { name: 'photos-list' },
    children: [
      {
        path: 'list',
        name: 'photos-list',
        component: PhotosList,
        meta: {
          module: 'photos',
          title: 'Photos',
          parent: 'photos',
        },
        props: route => ({ asset_id: route.params.asset_id }),
      },
    ],
  },
];

export default routes;
